export default {
  username: 'บัญชีผู้ใช้',
  password: 'รหัสผ่าน'
};
